import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,AlertController ,LoadingController, ModalController} from 'ionic-angular';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos'
import { CompaniasProvider } from '../../providers/companias/companias'
import { Storage } from '@ionic/storage'
import { reorderArray } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service'
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'
import { ProductosProvider } from '../../providers/productos/productos';

@Component({
  selector: 'productos-translados',
  templateUrl: 'productos-translados.html',
  providers: [ AuthService ]
})
export class ProductosTransladosComponent {

  listaProductos = [];
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId
  listaproveedoraPorProducto
  listaproveedoraPorProductoEquivalencia =  []
  listaProducto = []
  proveedoraPorProductoId
  listaProductosSeleccionados
  allItems
  buscar:string =''
  realizandoUnaVenta:boolean= true
  queHago:boolean = true
  loader
  valorCuotaString: string= "0";
  valorCuota = 0;
  valorTransferirString: string= "0";
  valorTransferir =0;
  nombreProducto="";
  nombreProductoEquivalencia="";
  existenciasActuales = 0;
  existenciasActualesPPPE = 0;
  producto: any;
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  dataproductos:any[] = []
  mostrarGridProductos: boolean = true
  productosSeleccionados:any[] =[]
  uuid:string = ''
  productosId = undefined
  tipoproducto = 'P'
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio: ProductosPorGruposProvider,
              public servicioCompania:CompaniasProvider,
              private storage: Storage,
              public alertControllers:AlertController,
              public auth: AuthService,
              public loadingCtrl:LoadingController,
              public modalControllers: ModalController,
              public utils: UtilsProvider,
              public servicioProductos:ProductosProvider) {
                this.buscarValoresProductos()
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{
      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']

      }
    })
    this.buscarDatos()
  }

  buscarDatos(){
    this.storage.get('companiasId').then((val) => {
      this.companiasId = val
    this.servicio.buscarProductosTraslados(val)
    .subscribe(
      res => {
        this.listaProducto = !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
       // this.listaproveedoraPorProducto = !NUBE_AWS ? res : JSON.parse(res['_body']).data[1]
      },
      err => {
      }
    )
  })

  }

  async ngOnInit() {
    // Obtener el producto pasado desde el componente principal
    this.producto = this.navParams.get('producto');
    if(this.producto !== undefined) {
      this.cargarProductos(this.producto)
    }
  }

  async cargarProductos(productos:any) {
    let companiaId = await this.storage.get('companiasId')
    this.servicio.buscarProductostraslados(companiaId,'','')
  }


  reorderItems(indexes) {
    this.listaproveedoraPorProductoEquivalencia = reorderArray(this.listaproveedoraPorProductoEquivalencia, indexes);
  }

  ionViewDidLoad() {
  }

  buscarporCompania(item:any){
    this.listaproveedoraPorProductoEquivalencia = []
    this.nombreProducto = ""
    this.nombreProductoEquivalencia = ""
    if (typeof item === 'number') {
      return
    }
    let proveedoraPorProductoId = this.listaproveedoraPorProducto[item] !== undefined  ? this.listaproveedoraPorProducto[item].proveedoraPorProductoId : 0
    let listaProveedorSelect = this.listaProducto.filter((item) => item.proveedoraPorProductoId == proveedoraPorProductoId)
    this.proveedoraPorProductoId =listaProveedorSelect.length > 0 ? listaProveedorSelect[0].proveedoraPorProductoId: 0
    let id = this.proveedoraPorProductoId == undefined || this.proveedoraPorProductoId === 0 ? 0 :this.proveedoraPorProductoId
    this.proveedoraPorProductoId = item
    item = undefined
    this.storage.get('companiasId').then((val)=>{
      if(id !== 0) {
        this.servicio.buscarProveedoraProductosEquivalenciaPorProveedoraPorProductoIdDrag(val,id)
          .subscribe((res: any) => {
              let response =  !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
              this.listaproveedoraPorProductoEquivalencia = response.length > 0 ? response : []
              this.nombreProducto = response.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].nombreProducto: ""
              this.nombreProductoEquivalencia  = response.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].nombreProductoEquivalencia: ""
              this.existenciasActuales =  response.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].existenciasActuales: 0
              this.existenciasActualesPPPE =  response.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].existenciasActualesPPPE: 0
            },
            err => {
              let alert = this.alertControllers.create({
                title: 'Error',
                subTitle: 'No se pudieron listar los valores, intente luego',
                buttons: ['Cerrar']
              });
              alert.present();
            })
        }
    })

  }

  agregarAlCarrito(item, proveedoraPorProductoIdRepo:any, posicion:any, listaProducto: any) {
        let companiasId = item['companiasId']

          this.servicio.buscarProveedoraPorProductosIdEquivalencia(companiasId,item)
          .subscribe((res: any) => {
              this.listaproveedoraPorProductoEquivalencia =  !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
              this.nombreProducto = this.listaproveedoraPorProductoEquivalencia[0].nombreProducto
              this.nombreProductoEquivalencia  = this.listaproveedoraPorProductoEquivalencia.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].nombreProductoEquivalencia: ""
              this.existenciasActuales =  this.listaproveedoraPorProductoEquivalencia.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].existenciasActuales: 0
              this.existenciasActualesPPPE =  this.listaproveedoraPorProductoEquivalencia.length > 0 ? this.listaproveedoraPorProductoEquivalencia[0].existenciasActualesPPPE: 0
            },
            err => {
              let alert = this.alertControllers.create({
                title: 'Error',
                subTitle: 'No se pudieron listar los valores, intente luego',
                buttons: ['Cerrar']
              });
              alert.present();
            })
        // }

      }

      onEvent(event: string, item: any){

        if (event === 'onTextChange') {

         let valor = this.getItems(this.buscar);
         if(valor){
              item = valor
        }
        }
        }

        getItems(event: any): void {
          if(!this.allItems){
            let valores = this.listaProductosSeleccionados
            this.allItems = valores;
          }
            this.listaProductosSeleccionados = this.allItems.filter((item) => {
              return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
      }

      cerrarSession(){
        this.auth.logout()
        this.navCtrl.setRoot('LoginPage');
      }


      buscarUuidGrupos(){

        let data = []
        let valorComparar = Number(this.proveedoraPorProductoId)
        for(let k=0;k< this.listaProducto.length;k++){
          if(k === valorComparar){

            data.push({
              proveedoraPorProductoId : this.listaProducto[k].proveedoraPorProductoId
            })
            k = this.listaProducto.length + 1
          }
        }

        return data

      }

      buscarUuidGruposItem(){

        let data = []
        let valorComparar = Number(this.proveedoraPorProductoId)
        for(let k=0;k< this.listaProducto.length;k++){
          if(k === valorComparar){

            data.push({
              item: this.listaProducto[k]
            })
            k = this.listaProducto.length + 1
          }
        }

        return data

      }

      limpiar(){
        this.listaProductos = []
        this.listaproveedoraPorProductoEquivalencia = []
        this.nombreProducto = ""
        this.nombreProductoEquivalencia = ""
        this.existenciasActuales = 0
        this.existenciasActualesPPPE = 0
        this.realizandoUnaVenta = true
        this.proveedoraPorProductoId = undefined
        this.buscar=''
      }
      mostrarMensajeDeError(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      mostrarMensajeAdvertencia(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Advertencia',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }


      mostrarMensajeExito(mensaje) {
        let alert = this.alertControllers.create({
          title: 'Registro exitoso',
          subTitle: mensaje,
          buttons: ['Cerrar']
        });
        alert.present();
      }
      procesarResultado() {
        this.limpiar()
        this.buscarDatos()
      }


      eliminarValor(item:any,i:any){
        console.log(item,i)
      }

      actualizarRegistro(item,i){
        let valorProducto = item.productosElaboradosId
        let proveedoraPorProductoEquivalenciaId = this.listaproveedoraPorProductoEquivalencia[i].proveedoraPorProductoEquivalenciaId
        let proveedoraPorProductoId = 0
        if(this.proveedoraPorProductoId===undefined){
          this.mostrarMensajeAdvertencia('Debe seleccionar un valor en el campo Productos equivalencia')
          return
        } else {
          proveedoraPorProductoId = this.listaproveedoraPorProducto[this.proveedoraPorProductoId].proveedoraPorProductoId
          this.proveedoraPorProductoId = proveedoraPorProductoId
        }
        let valor = ""
        if(typeof item.equivalencia !== 'number') {
            valor = item.equivalencia.replace(/[\.,]/g, '');
            item.equivalencia = valor
        }
        if(item.equivalencia === 0) {
          item.equivalencia = 1
        }

        let companiasId = item.companiasId
        if(proveedoraPorProductoEquivalenciaId!==0){
          item.proveedoraPorProductoId = this.proveedoraPorProductoId
          item.productosElaboradosId = valorProducto
          this.servicio.actualizarlistaproveedoraPorProductoEquivalencia(item)
          .subscribe((data)=>{
            this.procesarResultado()
            this.utils.mensajeMuestro('Producto equivalencia','Registro guardado con exito','success')
          },(error)=>{
            console.log(error)
          })
        }else{
          this.utils.mensajeMuestro('Producto equivalencia','Debe ingresar un valor valido','warning')
        }


      }

      searchSimple(cantidadafnSimple:any,item,index){
        setTimeout(() => {

            if(Number(cantidadafnSimple['_value'])==0 || isNaN(cantidadafnSimple['_value']) ){
             return
           }

           let cantidad = Number(cantidadafnSimple['_value'])

           let nuevaCantidad = Number(cantidad)
           return


         },1000)
       }

       DECIMAL_SEPARATOR  = '.'
       GROUP_SEPARATOR = ','

       format(valString) {
         if (!valString) {
             this.valorCuota = 0
             return '';
         }
         let val = valString.toString();
         try {
             this.valorCuota = Number(val.replace(/,/g, ''))
         } catch (e) {
             this.valorCuota = 0
         }

         const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR);
         return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR + parts[1]);
     };

     unFormat(val) {
      if (!val) {
          return '';
      }
      val = val.replace(/^0+/, '');

      if (this.GROUP_SEPARATOR === ',') {
          return val.replace(/,/g, '');
      } else {
          return val.replace(/\./g, '');
      }
  };


  searchSimpleTransferir(cantidadafnSimple:any,item,index){
    setTimeout(() => {

        if(Number(cantidadafnSimple['_value'])==0 || isNaN(cantidadafnSimple['_value']) ){
         return
       }

       let cantidad = Number(cantidadafnSimple['_value'])

       let nuevaCantidad = Number(cantidad)
       return


     },1000)
   }

  transferirCantidad(item: any, i:any, proveedorPorProductoId, existenciasActuales, existenciasActualesPPPE) {
    let productosElaboradosIdProveedor = proveedorPorProductoId.productosElaboradosId
    let companiasId = item.companiasId
    let equivalencia = item.equivalencia
    let valorTransferir = item.valorTransferir
    let productosId = item.productosElaboradosId
    if (
      companiasId !== undefined &&
      productosId !== undefined &&
      valorTransferir !== undefined && valorTransferir > 0 &&
      equivalencia !== undefined && equivalencia > 0
    ){
      let total = Number(valorTransferir)
      if(total > existenciasActuales) {
        this.utils.mensajeMuestro('Producto equivalencia','La cantidad que desea transferir supera la cantidad existente','warning')
        return
      }

      this.utils.mensajeConfirmacionDos('Producto equivalencia',`¿Está Seguro de transferir a ${this.nombreProductoEquivalencia} la cantidad  ${total} ? ` ,'question','Si','No')
      .then((transferirCantidad: boolean) => {
       if (transferirCantidad) {

        this.servicio.transferirCantidadPorProducto(companiasId, productosId,valorTransferir,equivalencia, productosElaboradosIdProveedor )
            .subscribe((data)=>{
              this.procesarResultado()
              this.utils.mensajeMuestro('Producto equivalencia','Registro guardado con exito','success')
            },(error)=>{
              console.log(error)
            })


       }
       else {
         this.utils.mensajeMuestro('Producto equivalencia','No se logro transferir la cantidad','warning')
       }

      })



    }
  }

  DECIMAL_SEPARATOR_VALOR_TRANSFERIR  = '.'
  GROUP_SEPARATOR_VALOR_TRANSFERIR = ','

    formatTransferir(valString) {
      if (!valString) {
          this.valorTransferir = 0
          return '';
      }
      let val = valString.toString();
      try {
          this.valorTransferir = Number(val.replace(/,/g, ''))
      } catch (e) {
          this.valorTransferir = 0
      }

      const parts = this.unFormat(val).split(this.DECIMAL_SEPARATOR_VALOR_TRANSFERIR);
      return parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, this.GROUP_SEPARATOR_VALOR_TRANSFERIR) + (!parts[1] ? '' : this.DECIMAL_SEPARATOR_VALOR_TRANSFERIR + parts[1]);
  };

  unFormatTransferir(val) {
  if (!val) {
      return '';
  }
  val = val.replace(/^0+/, '');

  if (this.GROUP_SEPARATOR_VALOR_TRANSFERIR === ',') {
      return val.replace(/,/g, '');
  } else {
      return val.replace(/\./g, '');
  }
  };

  selectInputContent(event: any) {
    const inputElement = event.target;
    if(inputElement && inputElement.value) {
      inputElement.setSelectionRange(0, inputElement.value.length);
    }
  }

  buscarProductos(event) {
    this.buscarTexto = event.value;
    this.mostrarGridProductos = true
  }
  actualizarValorProducto(item) {
  console.log(item)
  }

  async devolverValorProductos(item) {
    let data  = item;
    let productosId = Number(data.value)
    this.productosId = productosId
    let tipoproducto = data.tipo === 'Productos' ? 'P': 'E'
    this.tipoproducto = tipoproducto
    let nombreProducto = data.display
    this.existenciasActuales = data.existenciasActuales
    this.nombreProducto = nombreProducto
    this.buscarTexto = nombreProducto
    this.mostrarGridProductos = false
    if(tipoproducto === 'E') {
      this.mostrarMensajeAdvertencia('El producto seleccionado no puede ser un producto elaborado')
      return
    }
    let companiaId = await this.storage.get('companiasId')
    let UuidResponse = await this.servicioProductos.buscarUuidProductosTraslados(companiaId, productosId);
    this.uuid = ''
    if (UuidResponse && UuidResponse['_body']) {
      let a = UuidResponse['_body'];
      let b = JSON.parse(a);

      if (b && b.data && b.data.length > 0 && b.data[0].length > 0 && b.data[0][0].uuid) {
        this.uuid = b.data[0][0].uuid;
      } else {
        let productoUuid = require('uuid/v4');
        let Uuid = productoUuid()
        this.uuid = Uuid.substring(0,9)
      }
    } else {
      console.log('error')
    }
    let response = await this.servicioProductos.buscarCompaniasTraslados(companiaId,this.uuid)
    const parsedResponse = JSON.parse(response['_body']);

    // Verificamos si "data" existe y contiene información
    if (parsedResponse.data && parsedResponse.data.length > 0) {
      const arrayProductos = parsedResponse.data[0]; // Accede al array dentro de "data"

      console.log("Productos guardados:", arrayProductos);
      this.productosSeleccionados = arrayProductos

    } else {
    }
  }

  async buscarValoresProductos() {
    let companiaId = await this.storage.get('companiasId')
    this.servicioProductos.buscarTodosLosProductos(companiaId)
    .subscribe(async (data: any)=>{
      let productos: any = data;
      this.dataproductos = productos
    },(error)=> {console.log(error)})
  }

  async trasladar() {
    let companiasId = await this.storage.get('companiasId')
    let productoACambiar = this.productosSeleccionados.filter((item)=>  item.seleccionado === true)

    if(productoACambiar && productoACambiar.length>0) {
      // const nuevoArray = productoACambiar.map(element => {
      //   return {
      //     companiasId: element.companiasId,
      //     existenciasActuales: element.existenciasActuales == undefined ? 0 : element.existenciasActuales
      //   };
      // });
      const nuevoArray = productoACambiar.map(element => {
        return {
          companiasId: element.companiasId,
          existenciasActuales: element.existenciasActuales == undefined ? 0 : element.existenciasActuales
        };
      });



      const sumaExistencias = nuevoArray.reduce((total, element) => {
        return total + Number(element.existenciasActuales);
      }, 0);


      let usuariosId = await localStorage.getItem('usuariosId')
      let datosAdicionales = {
        companiasId:companiasId,
        uuid: this.uuid,
        productosId:Number(this.productosId),
        tipoproducto:this.tipoproducto,
        usuariosId:usuariosId,
        sumaExistencias:sumaExistencias
      }
    let response = await this.servicioProductos.actualizarValoresTraslado(nuevoArray,datosAdicionales)
    const parsedResponse = JSON.parse(response['_body']);
    if (parsedResponse.data && parsedResponse.data.length > 0) {
      // const arrayProductos = parsedResponse.data[0];
      // console.log("Productos guardados:", arrayProductos);
      // this.productosSeleccionados = arrayProductos
      } else {
    }
    this.nombreProducto = ""
    this.existenciasActuales = 0
    this.productosSeleccionados = []
    this.buscarValoresProductos()
   }

  }

  seleccionarRegistro(item:any) {
    console.log(item)
  }

}



// WEBPACK FOOTER //
// ./src/components/productos-translados/productos-translados.ts